<template>
	<div class="send-receipt-sheet">
		<AppBottomSheet :forceWidth="bottomSheetWidth" :active="ordersStore.sendReceiptData !== null" :z-index="1002" @toggling-popup="toggleBottomSheet">
			<div class="delivery-info-sheet-content" v-if="ordersStore.sendReceiptData">
				<ModalHeader :title="getString('send_receipt')"></ModalHeader>
				<AppList :items="sendItems" >
					<template v-slot:email-dropdown="{item}">
						<div class="email-container">
							<div class="ml-auto"><AppTextInput :placeholder="getString('email')" ref="email-receipt" type="email" /></div>
							<div class="ml-auto mt-10"><AppButton :text="getString('send')" @click="sendEmailReceipt" :loading="loadingSendEmail" /></div>
						</div>
					</template>
					<template v-slot:qr-dropdown="{item}">
						<div class="qr-container">
							<div class="ml-auto">
								<AppQrImage with-download-button :value="qrLink" />
							</div>
						</div>
					</template>
				</AppList>
			</div>
		</AppBottomSheet>
	</div>
</template>

<script>
import {useEpsonStore, useOrdersStore, usePrintersStore, useUserStore} from "@/console-new/stores";
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import AppList from "@/shared/components/AppList.vue";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import AppButton from "@/shared/components/AppButton.vue";
import API from "@/shared/helpers/API";
import AppChevronIcon from "@/shared/components/AppChevronIcon.vue";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import {validateEmail} from "@/shared/helpers/strings";
import AppQrImage from "@/shared/components/AppQrImage.vue";
import {isNative} from "@/shared/helpers/webapp";

export default {
	components: {AppQrImage, AppTextInput, AppChevronIcon, AppButton, ModalHeader, AppList, AppBottomSheet},
	setup() {
		const ordersStore = useOrdersStore();
		const languageStore = useLanguageStore();
		const printersStore = usePrintersStore();
		const epsonStore = useEpsonStore();
		const userStore = useUserStore();
		const notificationStore = useNotificationStore();
		return {
			userStore,
			printersStore,
			ordersStore,
			epsonStore,
			notificationStore,
			getString: languageStore.getString,
		}
	},
	mixins: [WindowWidth],
	name: "SendReceiptSheet",
	data() {
		return {
			loadingPrint: false,
			loadingSendEmail: false,
			sendReceiptOpen: false,
			showQrCode: false,
		}
	},
	computed: {
		bottomSheetWidth() {
			if (this.windowWidth < 550) {
				return "100%";
			} else if (this.windowWidth < 768) {
				return "550px";
			} else {
				return "720px";
			}
		},
		sendItems() {
			let items = [];
			items.push({
				title: this.getString("send_email"),
				chevronItem: true,
				dropdownSlot: "email-dropdown",
				active: this.sendReceiptOpen,
				callback: () => {
					this.sendReceiptOpen = !this.sendReceiptOpen;
					this.showQrCode = false;
				},
			});
			if(this.qrLink) {
				items.push({
					title: this.getString("share_qr_code"),
					chevronItem: true,
					dropdownSlot: "qr-dropdown",
					active: this.showQrCode,
					callback: () => {
						this.showQrCode = !this.showQrCode;
						this.sendReceiptOpen = false;
					},
				});
			}
			if(
				(!!this.printersStore.businessPrinters && this.printersStore.businessPrinters.length > 0)
				/* || isNative()*/
			) {
				items.push({
					title: this.getString("print_fiscal_receipt"),
					buttonTitle: this.getString("print"),
					callbackButton: () => {
						this.printReceipt();
					},
					buttonLoading: this.loadingPrint,
				});
			}
			return items;
		},
		qrLink() {
			if(this.ordersStore.sendReceiptData.id_encrypted && this.userStore.currBusiness.link) {
				return (LOCAL ? "http://" : "https://") + this.userStore.currBusiness.link + "." + HOST + "/order/receipt/?id="+this.ordersStore.sendReceiptData.id_encrypted;
			} else {
				return null;
			}
		},
		sendReceiptId() {
			return this.ordersStore.sendReceiptData ? this.ordersStore.sendReceiptData.receipt_id : null;
		}
	},
	methods: {
		toggleBottomSheet(open) {
			if(!open) {
				this.ordersStore.sendReceiptData = null;
			}
		},
		printReceipt() {
			this.loadingPrint = true;
			API.init().printFiscalReceiptApiscontrino(this.userStore.currBusinessId, this.sendReceiptId, (r) => {
				if(r.result && r.result === "OK") {
					this.ordersStore.sendReceiptData = null;
				} else {
					this.notificationStore.showNotification("generic-fail");
				}
				this.loadingPrint = false;
			});
		},
		sendEmailReceipt() {

			let email = this.$refs["email-receipt"].currentValue;
			if(!email || !validateEmail(email)) {
				this.notificationStore.showNotification("wrong-email");
				return;
			}

			this.loadingSendEmail = true;
			API.init().sendFiscalReceiptEmail(this.userStore.currBusinessId, this.sendReceiptId, email, (r) => {
				this.loadingSendEmail = false;
				if(r && r.result && r.result === "OK") {
					this.$refs["email-receipt"].currentValue = "";
					this.ordersStore.sendReceiptData = null;
				} else {
					this.notificationStore.showNotification("generic-fail");
				}
			});
		},
	}
}
</script>

<style scoped lang="scss">

.send-receipt-sheet {

	.double-text-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 8px;

		.title {
			font-size: 14px;
			color: #9b9b9b;
		}

		.value {
			font-size: 16px;
			color: $primary;
			margin-left: auto;
			text-align: right;
		}

	}

}


.row-clickable {
	cursor: pointer;

	.chevron-container {
		height: 35px;
		display: flex;
		align-items: center;
	}
}

.email-container {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	justify-content: center;
	width: 100%;

}

.qr-container {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	justify-content: center;
	width: 100%;

}
</style>